import { Position } from "@/services/backend/rlt/treatments/types/position";
import { fPrice } from "@/services/backend/rlt/treatments/lib/utils";

export function FinalPriceCell({ position }: { position: Position }) {
  return (
    <div className="flex h-6 items-center justify-end font-bold whitespace-nowrap">
      {fPrice(position.finalPrice)} €
    </div>
  );
}
